import { PRIORITIES } from "@/lib/priority";

export const PriorityPicker = ({ value, onChange }) => (
  <div className="space-y-2">
    <div className="grid grid-cols-3 gap-2" data-testid="priority-picker">
      {PRIORITIES.map((p) => {
        const on = value === p.key;
        return (
          <button key={p.key} type="button" onClick={() => onChange(p.key)} data-testid={`priority-pick-${p.key}`}
            className="rounded-xl border p-3 text-left transition-[background-color,border-color] hover:bg-white/[0.04]"
            style={on ? { borderColor: p.color, background: `${p.color}1a` } : {}}>
            <span className="flex items-center gap-2 font-display text-base font-semibold" style={on ? { color: p.color } : {}}>
              <span className="h-2.5 w-2.5 rounded-full" style={{ background: p.color }} /> {p.label}
            </span>
            <span className="mt-1 block text-xs text-muted-foreground">{p.every}</span>
          </button>
        );
      })}
    </div>
    <div className="flex items-center justify-between text-xs text-muted-foreground">
      <span>Emails 9am–5pm until marked done</span>
      <button type="button" onClick={() => onChange("custom")} data-testid="priority-pick-custom"
        className={`underline-offset-4 hover:text-foreground hover:underline ${value === "custom" ? "font-semibold text-foreground" : ""}`}>
        Custom timing
      </button>
    </div>
  </div>
);
